export default "__VITE_ASSET__q3qcj9NH__"